import { State } from './types'

export const initialState: State = {
  map: undefined,
  isLoadedMap: false,
  drawingTool: {
    isActive: false,
    status: undefined,
  },
  isFlyTo: false,
  mapZoom: 0,
  hoveredLayer: undefined,
  clickedLayer: undefined,
  zonePolygons: []
}
